import { render, staticRenderFns } from "./TableSelected.vue?vue&type=template&id=0a1b31d6&scoped=true"
import script from "./TableSelected.vue?vue&type=script&lang=js"
export * from "./TableSelected.vue?vue&type=script&lang=js"
import style0 from "./TableSelected.vue?vue&type=style&index=0&id=0a1b31d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_pwz6xkwfkuu76k24ttivynkur4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1b31d6",
  null
  
)

/* custom blocks */
import block0 from "./TableSelected.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports